import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'

import {docsOrder, getDocAppLink, getDocTitle} from 'views/Documents/Documents.config'

import {LinksWrapper, Container} from './Footer.styles'

const Footer = ({...rest}) => {
  const {t} = useTranslation()
  return (
    <Container {...rest}>
      <LinksWrapper>
        {docsOrder.map(slug => (
          <Link key={slug} to={getDocAppLink(slug)}>
            {getDocTitle(slug, t)}
          </Link>
        ))}
      </LinksWrapper>
    </Container>
  )
}

export default Footer
